frappe.provide("frappe.help.help_links");
